class exports.RuppOrdersLicensesHandler extends DialogHandler
    init: () ->
        @layoutUrl = 'backend/grower/rupp-orders/load-layout-licenses'
        @refreshNavHandler = false
        @draggable = true
        @destroyOnSave = true
        @saveUrl = 'backend/grower/rupp-orders/save-licenses'
        @createDialog()


    afterLoadLayout: () ->
        @dialog.find('.save-btn').bind 'click', () =>
            @save('Saving License Numbers')

        @openDialog()


    getPostData: () ->
        data = {}
        data['users_id'] = $('input[name="hdn_users_id"]').val()
        data['licenses'] = []
        for elem in $('input[name="lisc_current"]')
            id = $(elem).val()
            cur = $(elem).is(':checked')
            num = $(elem).parent().prev().find('input').val()
            data['licenses'].push
                id: id
                cur: cur
                num: num

        return JSON.stringify data
